import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ConfigurationService } from '@sondermind/configuration';
import { Logger } from '@sondermind/datadog-logging';
import { getTranscendConsent } from '@sondermind/analytics';

@Injectable({
  providedIn: 'root'
})
export class ConsentSyncService {
  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
    private logger: Logger,
  ) { }

  registerConsentListener(): void {
    if (typeof window !== 'undefined') {
      (window as any)?.airgap?.ready?.((airgap: any) => {
        airgap.addEventListener('consent-change', () => this.syncConsent());
      });
    }
  }

  syncConsent(): void {
    if (typeof window === 'undefined' || !window?.airgap?.getConsent) {
      return;
    }

    const preferences = getTranscendConsent();

    const requiredKeys = ['Essential', 'Functional', 'Analytics', 'Advertising', 'SaleOfInfo'];
    const hasAllCategories = preferences != null && requiredKeys.every((key) => key in preferences);
    if (!hasAllCategories) {
      this.logger.debug('ConsentSyncService: skipping sync, consent categories not fully initialized', { preferences });
      return;
    }

    const url = `${this.configurationService.env.svcBase}/core/consent_preferences`;

    this.http.put(url, { preferences }).subscribe({
      error: (err) => this.logger.warn('ConsentSyncService: failed to sync consent preferences', { status: err.status }),
    });
  }
}
